import { render, staticRenderFns } from "./help_icon.vue.js?vue&type=template&id=b7e36a8e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_icon.vue?vue&type=template&id=b7e36a8e"
import script from "./help_icon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_icon.vue?vue&type=script&lang=js"
export * from "./help_icon.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7e36a8e')) {
      api.createRecord('b7e36a8e', component.options)
    } else {
      api.reload('b7e36a8e', component.options)
    }
    module.hot.accept("./help_icon.vue.js?vue&type=template&id=b7e36a8e!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_icon.vue?vue&type=template&id=b7e36a8e", function () {
      api.rerender('b7e36a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/help_icon/help_icon.vue"
export default component.exports